/**
 * Labstep
 *
 * @module constants/version
 * @desc App version
 */

export const APP_VERSION = '15.6.2';
